<template>
  <div class="sunx-browser">
    <p class="sunx-browser-hint">{{ $t('sunxHint') }}</p>
    <a
      class="sunx-browser-download"
      :href="downloadUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        class="sunx-browser-icon"
        alt=""
        aria-hidden="true"
        src="@/assets/images/sunx-browser.png"
      />
      <span>{{ $t('downloadSunx') }}</span>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { SUNX_PLAY_STORE_URL } from '@/constants/Sunx.constants';

const downloadUrl = SUNX_PLAY_STORE_URL;
</script>

<style scoped>
.sunx-browser {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.sunx-browser-hint {
  max-width: 22rem;
  font-size: 12px;
  line-height: 1.5;
  color: #dbe6fb;
}
.sunx-browser-download {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  width: fit-content;
  padding: 10px 16px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.15s;
}
.sunx-browser-download:hover {
  background: rgba(255, 255, 255, 0.24);
}
.sunx-browser-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
}
</style>
